window.loaded_time = true;
if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

       this.initQuantityHandlers();
       this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
       this.querySelectorAll('[data-details__plan-radio]').forEach(r => r.addEventListener('change', this.handlePlanChange.bind(this)));
      // Set default plan after everything is initialized
        setTimeout(() => {
          this.setDefaultPlan();
        }, 100);
        setTimeout(() => {
        const productUrl = this.dataset.url || window.location.href; // get product URL
        const html = document; // you can also fetch updated HTML if needed
        const updater = this.handleUpdateProductInfo(productUrl);

        // Force-select the first available variant
        const firstVariant = this.getSelectedVariant(html);
        if (firstVariant) {
          // Update UI/media/etc
          updater(html);

          // Ensure the inputs reflect the first variant as checked
          const variantInput = this.querySelector(
            `input[name="id"][value="${firstVariant.id}"]`
          );
          if (variantInput) { 
            variantInput.checked = true;
          }
        }
      }, 200);

      }

      setDefaultPlan() {
        // Find the first checked radio button (which should be monthly based on your Liquid code)
        const defaultPlanRadio = this.querySelector('[data-details__plan-radio]:checked');
        
        if (defaultPlanRadio) {
          // Create a synthetic event and trigger the plan change
          const syntheticEvent = {
            target: defaultPlanRadio
          };
          this.handlePlanChange(syntheticEvent);
        } else {
          // Fallback: find the first plan radio button and select it
          const firstPlanRadio = this.querySelector('[data-details__plan-radio]');
          if (firstPlanRadio) {
            firstPlanRadio.checked = true;
            
            // Update active plan styling
            this.updateActivePlan(firstPlanRadio);
            
            // Trigger the plan change
            const syntheticEvent = {
              target: firstPlanRadio
            };
            this.handlePlanChange(syntheticEvent);
          }
        }
      }

      // Helper method to update active plan styling
      updateActivePlan(selectedRadio) {
        // Remove active class from all plan buttons
        this.querySelectorAll('.product-details__plan-button').forEach(button => {
          button.classList.remove('is-active-plan');
        });
        
        // Add active class to the selected plan button
        const selectedLabel = this.querySelector(`label[for="${selectedRadio.id}"]`);
        if (selectedLabel) {
          selectedLabel.classList.add('is-active-plan');
        }
      }

      handlePlanChange(event) {

        const selectedPlanId = event.target.value;
        const targetId = event.target.id;

        const variantId = this.productForm?.variantIdInput?.value;

        const optionValues = Array.from(
            this.variantSelectors?.querySelectorAll(
              '[data-option-position][type="radio"]:checked, ' + 
              'select[data-option-position],' + 
              '[data-option-position][type="hidden"]'              
            ) || []
          )
          .map(el => el.value)
          .filter(Boolean);    


        let requestUrl;
        if (variantId) {
          requestUrl = `${this.dataset.url}?variant=${variantId}&selling_plan=${selectedPlanId}&section_id=${this.sectionId}`;
        } else {
          requestUrl = `${this.buildRequestUrlWithParams(this.dataset.url, optionValues)}&selling_plan=${selectedPlanId}`;
        }
        this.renderProductInfo({
          requestUrl,
          targetId,
          callback: this.handleUpdateProductInfo(this.dataset.url),
        });

      }


      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        if(this.querySelector('[data-details__plan-radio]:checked') != null){
         const plan = this.querySelector('[data-details__plan-radio]:checked')?.value;
          if (plan) params.push(`selling_plan=${plan}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          let variant = this.getSelectedVariant(html);
          if(variant == null) {
            var json = document.querySelector('script[type="application/json"][data_product_json]');
            var productData = JSON.parse(json.innerHTML);
            var first_input_name = document.querySelectorAll('.product-form__input')[0].querySelector('input[type="radio"]').attributes.name.value;
            var checkedInput = document.querySelector(`[name="${first_input_name.trim()}"]:checked`);

            console.log("Checked input:", checkedInput, "  ", first_input_name, " ", productData);

            variant = checkedInput
              ? productData.variants.find(v => v.title.indexOf(checkedInput.value) >= 0)
              : null;

            console.log(variant);
          
          var option1 = variant.option1?.toLowerCase().replace(/\s+/g, "_");
          const strapSelection = document.querySelector('.product-details__strap-selection.custom-strap-selection');

          if (strapSelection) {
            const inputs = strapSelection.querySelectorAll('.swatch-input__input');
            
            // helper → normalize value like option1/option2
            const normalize = val => val?.toLowerCase().replace(/\s+/g, "_");

            // 1️⃣ Initial check — if any is already checked
            const initiallyChecked = strapSelection.querySelector('.swatch-input__input:checked');
            if (initiallyChecked) {
              const selectedValue = normalize(initiallyChecked.value);
              const matchKey = [selectedValue, option1].filter(Boolean).join("_");
              strapSelection.setAttribute("data-selected-strap", matchKey);
            }

            // 2️⃣ ONLY attach listeners if they haven't been attached before
            if (!this.strapListenersAttached) {
              // IMPORTANT: Capture 'this' context before entering the callback
              const self = this;  // Store reference to the class instance
              
              inputs.forEach(input => {
                input.addEventListener('click', function(e) {
                  console.log("Strap click event fired");
                  // Small delay to ensure the checked state is updated
                  setTimeout(() => {
                    const checked = strapSelection.querySelector('.swatch-input__input:checked');
                    if (checked) {
                      const selectedValue = normalize(checked.value);
                      console.log("Selected strap value:", selectedValue);
                      // Get current variant (recalculate since it might have changed)
                      const currentVariant = self.getSelectedVariant(document);
                      const currentOption1 = currentVariant?.option1?.toLowerCase().replace(/\s+/g, "_");
                      
                      const matchKey = [selectedValue, currentOption1].filter(Boolean).join("_");
                      strapSelection.setAttribute("data-selected-strap", matchKey);
                      
                      if (self.updateMediaNew && typeof self.updateMediaNew === 'function') {
                        console.log("Calling updateMediaNew");
                        self.updateMediaNew(html, currentVariant?.featured_media?.id);
                      } else if (self.updateMedia && typeof self.updateMedia === 'function') {
                        console.log("Calling updateMedia fallback");
                        self.updateMedia(html, currentVariant?.featured_media?.id);
                      } else {
                        console.log("No media update function found");
                      }
                    }
                  }, 10);
                });
              });
              // Mark that listeners have been attached
              this.strapListenersAttached = true;
            } else {
              console.log("Strap listeners already attached, skipping");
            }
          }
          }

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);
          if(window.loaded_time == false) {
            this.updateMediaNew(html, variant?.featured_media?.id);
          }

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('stock_level');
          updateSourceFromDestination('details_total_price');
          updateSourceFromDestination('details__plans');
          // updateSourceFromDestination('variants');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          if(this.querySelectorAll('[data-details__plan-radio]').length > 0){
            this.querySelectorAll('[data-details__plan-radio]').forEach(r => r.addEventListener('change', this.handlePlanChange.bind(this)));
          }

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);

        const sellingPlanId = this.querySelector('[data-details__plan-radio]:checked')?.value;

        const u = new URL(url, window.location.origin);
        variantId   ? u.searchParams.set('variant', variantId) : u.searchParams.delete('variant');
        sellingPlanId ? u.searchParams.set('selling_plan', sellingPlanId) : u.searchParams.delete('selling_plan');

        const finalPath = u.pathname + u.search;

        this.querySelector('share-button')?.updateUrl(`${window.shopUrl}${finalPath}`);

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', finalPath);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules','stock_level','details_total_price',"details__plans"]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      // this is new function that works on varint change and match the alt text for the image and chnage image based on that 
      
      updateMediaNew(html, variantFeaturedMediaId) {
        var variant = this.getSelectedVariant(html);
         if(variant == null) {
            var json = document.querySelector('script[type="application/json"][data_product_json]');
            var productData = JSON.parse(json.innerHTML);
            var first_input_name = document.querySelectorAll('.product-form__input')[0].querySelector('input[type="radio"]').attributes.name.value;
            var checkedInput = document.querySelector(`[name="${first_input_name}"]:checked`);

            variant = checkedInput
              ? productData.variants.find(v => v.title.indexOf(checkedInput.value) >= 0)
              : null;
            
           let hiddenFirst = document.querySelector("[data-value_available_true] input[type='radio']");

            if (hiddenFirst) {
              hiddenFirst.checked = true; 
              hiddenFirst.dispatchEvent(new Event("change", { bubbles: true })); 
            }

            console.log(variant);
          }
        const option1 = variant.option1?.toLowerCase().replace(/\s+/g, "_");
        const option2 = variant.option2?.toLowerCase().replace(/\s+/g, "_");
        const strapSelection = document.querySelector('.product-details__strap-selection.custom-strap-selection');

          let matchKey;
          if (strapSelection && strapSelection.hasAttribute("data-selected-strap")) {
            matchKey = strapSelection.getAttribute("data-selected-strap");
          } else {
            matchKey = [option1, option2].filter(Boolean).join("_");
          }

          console.log("Updated log!");

        // Get the current slider containers
        const productNavSlider = this.querySelector('.js-product-nav-slider');
        const productThumbSlider = this.querySelector('.js-product-thumb-slider');
        
        // Get the new slider containers from html
        const newProductNavSlider = html.querySelector('.js-product-nav-slider');
        const newProductThumbSlider = html.querySelector('.js-product-thumb-slider');

        if (productNavSlider && productThumbSlider && newProductNavSlider && newProductThumbSlider) {
            // Get current slides
            const currentNavSlides = Array.from(productNavSlider.querySelectorAll('.product-details__slide'));
            const currentThumbSlides = Array.from(productThumbSlider.querySelectorAll('.product-details__slide'));
            
            // Get new slides
            const newNavSlides = Array.from(newProductNavSlider.querySelectorAll('.product-details__slide'));
            const newThumbSlides = Array.from(newProductThumbSlider.querySelectorAll('.product-details__slide'));

            // Create sets for comparison (using data-media-position or image src as identifier)
            const getCurrentSlideId = (slide) => {
                const img = slide.querySelector('img');
                return slide.dataset.mediaPosition || (img ? img.src : '');
            };

            const currentNavSet = new Set(currentNavSlides.map(getCurrentSlideId));
            const currentThumbSet = new Set(currentThumbSlides.map(getCurrentSlideId));
            const newNavSet = new Set(newNavSlides.map(getCurrentSlideId));
            const newThumbSet = new Set(newThumbSlides.map(getCurrentSlideId));

            let needsRebuild = false;

            // Check if slides have changed
            if (currentNavSet.size !== newNavSet.size || 
                currentThumbSet.size !== newThumbSet.size ||
                !Array.from(currentNavSet).every(id => newNavSet.has(id)) ||
                !Array.from(currentThumbSet).every(id => newThumbSet.has(id))) {
                needsRebuild = true;
            }

            if (needsRebuild) {
                // Destroy existing slick sliders
                if ($(productNavSlider).hasClass('slick-initialized')) {
                    $(productNavSlider).slick('unslick');
                }
                if ($(productThumbSlider).hasClass('slick-initialized')) {
                    $(productThumbSlider).slick('unslick');
                }

                // Update the slider content
                const navSlickList = productNavSlider.querySelector('.slick-list .slick-track');
                const thumbSlickList = productThumbSlider.querySelector('.slick-list .slick-track');
                
                if (navSlickList && thumbSlickList) {
                    // Replace the content
                    navSlickList.innerHTML = newProductNavSlider.querySelector('.slick-list .slick-track').innerHTML;
                    thumbSlickList.innerHTML = newProductThumbSlider.querySelector('.slick-list .slick-track').innerHTML;
                } else {
                    // If no slick structure exists, replace entire slider content
                    const navSliderContent = productNavSlider.innerHTML;
                    const thumbSliderContent = productThumbSlider.innerHTML;
                    productNavSlider.innerHTML = newProductNavSlider.innerHTML;
                    productThumbSlider.innerHTML = newProductThumbSlider.innerHTML;
                }

                // Reinitialize the sliders with the same configuration as your original code
                this.initializeSlickSliders(productNavSlider, productThumbSlider);
            }
        }

        // Find and activate the matching slide based on matchKey
        this.activateSlideByMatchKey(matchKey, variantFeaturedMediaId);

        // Update media modal if exists
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) {
            modalContent.innerHTML = newModalContent.innerHTML;
        }
      }

      // Helper function to initialize Slick sliders
      initializeSlickSliders(productNavSlider, productThumbSlider) {
          const navSlides = productNavSlider.querySelectorAll('.product-details__slide');
          const thumbSlides = productThumbSlider.querySelectorAll('.product-details__slide');

          if (navSlides.length > 0 && thumbSlides.length > 0) {
              // Initialize nav slider
              $(productNavSlider).slick({
                  arrows: true,
                  infinite: false,
                  slidesToShow: parseFloat($(productNavSlider).attr('data-slide-desktop'), 10) || 1,
                  slidesToScroll: 1,
                  autoplay: false,
                  centerMode: false,
                  asNavFor: productThumbSlider,
                  fade: true,
                  prevArrow: '<button type="button" class="slick-arrow slick-prev-arrow slick-prev"><svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 7.09619C17.5523 7.09619 18 7.54391 18 8.09619C18 8.64848 17.5523 9.09619 17 9.09619V7.09619ZM0.292892 8.8033C-0.0976315 8.41277 -0.0976315 7.77961 0.292892 7.38908L6.65685 1.02512C7.04738 0.634599 7.68054 0.634599 8.07107 1.02512C8.46159 1.41565 8.46159 2.04881 8.07107 2.43934L2.41421 8.09619L8.07107 13.753C8.46159 14.1436 8.46159 14.7767 8.07107 15.1673C7.68054 15.5578 7.04738 15.5578 6.65685 15.1673L0.292892 8.8033ZM17 8.09619V9.09619H1V8.09619V7.09619H17V8.09619Z" fill="#222222"></path></svg></button>',
                  nextArrow: '<button type="button" class="slick-arrow slick-next-arrow slick-next"><svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 7.09619C0.447715 7.09619 0 7.54391 0 8.09619C0 8.64848 0.447715 9.09619 1 9.09619V7.09619ZM17.7071 8.8033C18.0976 8.41277 18.0976 7.77961 17.7071 7.38908L11.3431 1.02512C10.9526 0.634599 10.3195 0.634599 9.92893 1.02512C9.53841 1.41565 9.53841 2.04881 9.92893 2.43934L15.5858 8.09619L9.92893 13.753C9.53841 14.1436 9.53841 14.7767 9.92893 15.1673C10.3195 15.5578 10.9526 15.5578 11.3431 15.1673L17.7071 8.8033ZM1 8.09619V9.09619H17V8.09619V7.09619H1V8.09619Z" fill="#222222"></path></svg></button>',
                  responsive: [
                      {
                          breakpoint: 992,
                          settings: {
                              slidesToShow: parseFloat($(productNavSlider).attr('data-slide-tab'), 10) || 1,
                          }
                      },
                      {
                          breakpoint: 768,
                          settings: {
                              slidesToShow: parseFloat($(productNavSlider).attr('data-slide-mobile'), 10) || 1,
                          }
                      }
                  ]
              });

              // Handle scroll class for thumb slider
              if (window.innerWidth <= 992) {
                  if (thumbSlides.length <= 4 && !productThumbSlider.classList.contains('no-scroll')) {
                      productThumbSlider.classList.add('no-scroll');
                  } else if (productThumbSlider.classList.contains('no-scroll')) {
                      productThumbSlider.classList.remove('no-scroll');
                  }
              } else {
                  if (thumbSlides.length <= 6 && !productThumbSlider.classList.contains('no-scroll')) {
                      productThumbSlider.classList.add('no-scroll');
                  } else if (productThumbSlider.classList.contains('no-scroll')) {
                      productThumbSlider.classList.remove('no-scroll');
                  }
              }

              // Initialize thumb slider
              $(productThumbSlider).slick({
                  arrows: false,
                  infinite: false,
                  slidesToShow: parseFloat($(productThumbSlider).attr('data-slide-desktop'), 10) || 6,
                  slidesToScroll: 1,
                  autoplay: false,
                  centerMode: false,
                  asNavFor: productNavSlider,
                  focusOnSelect: true,
                  responsive: [
                      {
                          breakpoint: 992,
                          settings: {
                              slidesToShow: parseFloat($(productThumbSlider).attr('data-slide-tab'), 10) || 4.5,
                          }
                      },
                      {
                          breakpoint: 768,
                          settings: {
                              slidesToShow: parseFloat($(productThumbSlider).attr('data-slide-mobile'), 10) || 4.5,
                          }
                      }
                  ]
              });

              // Add event listeners
              $(productNavSlider).on('afterChange', function(event, slick, currentSlide) {
                  // updateSlideVideoState(productNavSlider); // Uncomment if you have this function
              });

              // Add video event listeners if you have videos
              const navVideos = productNavSlider.querySelectorAll('video');
              navVideos.forEach(video => {
                  video.addEventListener('ended', function () {
                      let slide = video.closest('.product-details__slide');
                      let playBtn = slide.querySelector('.js-product-details-icon-play');
                      let pauseBtn = slide.querySelector('.js-product-details-icon-pause');

                      if (slide) slide.classList.remove('is-playing');
                      if (playBtn) playBtn.style.display = 'flex';
                      if (pauseBtn) pauseBtn.style.display = 'none';
                  });
              });

              // Add click event listeners for video controls
              productNavSlider.addEventListener('click', function (event) {
                  let playBtn = event.target.closest('.js-product-details-icon-play');
                  let pauseBtn = event.target.closest('.js-product-details-icon-pause');

                  if (playBtn) {
                      let slide = playBtn.closest('.product-details__slide');
                      let video = slide.querySelector('video');
                      let pauseIcon = slide.querySelector('.js-product-details-icon-pause');
                      if (video) {
                          video.play();
                          slide.classList.add('is-playing');
                          playBtn.style.display = 'none';
                          if (pauseIcon) pauseIcon.style.display = 'flex';
                      }
                  }

                  if (pauseBtn) {
                      let slide = pauseBtn.closest('.product-details__slide');
                      let video = slide.querySelector('video');
                      let playIcon = slide.querySelector('.js-product-details-icon-play');
                      if (video) {
                          video.pause();
                          slide.classList.remove('is-playing');
                          pauseBtn.style.display = 'none';
                          if (playIcon) playIcon.style.display = 'flex';
                      }
                  }
              });
          }
      }

      // Helper function to activate slide by matchKey
      activateSlideByMatchKey(matchKey, variantFeaturedMediaId) {
          const productNavSlider = this.querySelector('.js-product-nav-slider');
          
          if (!productNavSlider || !matchKey) {
              return;
          }

          const slides = productNavSlider.querySelectorAll('.product-details__slide');
          let targetSlideIndex = -1;

          // Find matching slide based on alt text
          slides.forEach((slide, index) => {
              const img = slide.querySelector('img');
              if (img && img.alt) {
                  const altTextFormatted = img.alt.toLowerCase().replace(/\s+/g, "_");
                  
                  // Check if matchKey matches the alt text
                  if (altTextFormatted.includes(matchKey) || matchKey.includes(altTextFormatted)) {
                      targetSlideIndex = index;
                      return;
                  }
              }
          });

          // If no match found and we have variantFeaturedMediaId, try to find by media position
          if (targetSlideIndex === -1 && variantFeaturedMediaId) {
              slides.forEach((slide, index) => {
                  if (slide.dataset.mediaPosition == variantFeaturedMediaId) {
                      targetSlideIndex = index;
                      return;
                  }
              });
          }

          // Activate the found slide
          if (targetSlideIndex !== -1 && $(productNavSlider).hasClass('slick-initialized')) {
              $(productNavSlider).slick('slickGoTo', targetSlideIndex);
          }
      }


      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}


var moved = false;
var variantsBlock = document.querySelector(".product-details__variants");
var rightCol = document.querySelector(".product-details__right");
var leftCol = document.querySelector(".product-details__left");

if (variantsBlock && rightCol && leftCol) {
  var wrapper = document.createElement("div");

  function moveOnMobile() {
    if (window.innerWidth <= 768 && !moved) {
      let nodesToMove = [];
      let prev = variantsBlock.previousElementSibling;
      while (prev) {
        nodesToMove.unshift(prev);
        prev = prev.previousElementSibling;
      }
      nodesToMove.forEach(function (el) {
        wrapper.appendChild(el);
      });

      if (leftCol.firstChild) {
        leftCol.insertBefore(wrapper, leftCol.firstChild);
      } else {
        leftCol.appendChild(wrapper);
      }

      moved = true;
    } else if (window.innerWidth > 768 && moved) {
      var parent = variantsBlock.parentNode;
      while (wrapper.firstChild) {
        parent.insertBefore(wrapper.firstChild, variantsBlock);
      }
      wrapper.remove();
      moved = false;
    }
  }

  moveOnMobile();
  window.addEventListener("resize", moveOnMobile);

  $(document).on('change', '.swatch-input__input_strap_custom', function () {
  let val = $(this).val();
  $('.swatch-input__input[value="' + val + '"]').trigger('click');
});

}
